<template>
  <teleport to="body">
    <div v-if="open" class="modal" @click.self.prevent="open = !open">
      <div class="wrapper">
        <div class="content">
          <font-awesome-icon class="exit" icon="fa-xmark" @click="open = !open" />
          <h3 class="title">Create / Edit Discount</h3>

          <div class="field">
            <label>Active / Available Discount</label>
            <ToggleSwitch onLabel="Available" offLabel="Unavailable" :modelValue="currentDiscount.active" modelName="active" @update:modelValue="updateActive" />
          </div>

          <div class="field">
            <label>Name</label>
            <input type="text" :disabled="!currentDiscount.pending" v-model="currentDiscount.name" placeholder="e.g. Staff Discount" />
          </div>
          <div class="field">
            <label>Type</label>
            <ToggleSwitch class="type" onLabel="Fixed Value" offLabel="Percentage" :modelValue="currentDiscount.type" modelName="type" @update:modelValue="updateType" />
          </div>
          <div class="field">
            <label>Value</label>
            <input type="text" v-model.number="currentDiscount.value" placeholder="123" />
          </div>
        </div>

        <div class="actions">
          <button class="action danger" @click.prevent.stop="remove">Delete</button>
          <!-- <button class="action cancel" @click.prevent.stop="cancel">Cancel</button> -->
          <button class="action primary action-colour" @click.prevent.stop="commit">Save</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { ToggleSwitch } from "@monolith/components";

export default {
  name: "DiscountModal",
  props: ["show", "discount"],
  emits: ["save", "remove"],
  components: { ToggleSwitch },
  data() {
    return {
      open: false,
      currentDiscount: { name: null, type: null, value: null, description: null, active: false },
    };
  },
  methods: {
    updateActive(value) {
      this.currentDiscount.active = value;
    },
    updateType(value) {
      this.currentDiscount.type = value;
    },
    remove() {
      this.$emit("remove", this.currentDiscount);
      this.open = false;
    },
    cancel() {
      this.open = !this.open;
    },
    commit() {
      this.$emit("save", this.currentDiscount);
      this.open = false;
    },
  },
  watch: {
    show() {
      this.open = true;
    },
    discount() {
      this.currentDiscount = this.discount;
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.modal {
  .wrapper {
    background-color: var(--primary-colour);
    color: var(--text-colour);
    padding: 1rem;
    // box-shadow: 2px 2px 2px #ccc;
  }

  .cancel {
    color: var(--text-colour);
  }
  div.content {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;

    .field {
      // border: 1px solid black;
      border-radius: 0.5rem;
      margin: 0.5rem;
      padding: 0.5rem;
      display: flex;
      flex-direction: column;
      background-color: var(--secondary-colour);
      // box-shadow: var(--box-shadow);

      input {
        border-radius: 0.5rem;
        background-color: var(--primary-colour);
        margin-left: 1rem;
        color: var(--text-colour);
      }
    }

    textarea {
      min-height: 100px;
      height: 4rem !important;
    }

    img {
      display: block;
      width: 200px;
    }

    ul.modifiersets {
      flex: 1 1;
      list-style: none;
      margin: 0px;
      margin-right: 1rem;
      padding: 0px;
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      grid-auto-flow: row;
      grid-column-gap: 1rem;
      grid-row-gap: 1rem;
      //flex-wrap: wrap;
      //justify-content: stretch;

      li button {
        position: relative;
        cursor: pointer;
        flex: 1 1;
        padding: 2rem;
        width: 100%;
        min-height: 100px;
        margin: 0.2rem;
        background-color: #aaa;
        border-color: var(--hover-colour);
        border-style: none;

        &.selected {
          background-color: #dfe7f0;
          border: 1px solid #dfe7f0;
        }
      }
    }
  }
}
.type {
  --toggle-bg-off: #65da3b;
}

@media only screen and (orientation: portrait) {
  .actions {
    margin-right: 0.5rem !important;
    .action {
      max-width: 5rem;
    }
    .danger {
      margin-right: 4.5rem !important;
      min-width: 2rem;
    }
  }
}
</style>
